module.exports = __webpack_public_path__ + "static/onlnecasino_logo-b9bbcbb78ab6ede560bee8aa3a655a82.png";